import { Map, TileLayer as TileLayerEntity } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useRef } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import { DialogWaterLevel } from 'src/modules/mizusaki/components/DialogWaterLevel.component';
import { TileLayerControlTopRight } from './TileLayerControlTopRight.component';
import { LeafletProps } from './types/leaflet-props.type';
import '../../mizusaki/styles/LeafletMizusaki.css';
export function LeafletMizusaki({ mapContainerProps }: LeafletProps) {
  const baseTileLayer = useRef<TileLayerEntity>(new TileLayerEntity(''));
  const map = useRef<Map>(null);

  return (
    <>
      <DialogWaterLevel />
      <MapContainer attributionControl={false} {...mapContainerProps} ref={map}>
        <TileLayer url="" ref={baseTileLayer} maxNativeZoom={18} />
        <TileLayerControlTopRight baseTileLayer={baseTileLayer} map={map} />
      </MapContainer>
    </>
  );
}
